import React, { PropsWithChildren } from 'react';
import Bem from '../../../../lib/bemUtils/bem';
import { AccordionTitleModifier } from './Accordion.modifier';

interface AccordionTitleProps {
  category?: string;
  modifier?: AccordionTitleModifier;
}

export function AccordionTitle({ category, modifier, children }: PropsWithChildren<AccordionTitleProps>) {
  return (
    <span className={Bem('accordion__category-title', modifier)}>
      <span className="accordion__category-text">{children || category}</span>
    </span>
  );
}
